import {useMutation} from "@tanstack/react-query";

import {removeServiceNoteMutationOptions} from "./remove-service-note.mutation-options";

export function useRemoveServiceNote(id: string) {
  return useMutation(removeServiceNoteMutationOptions(id));
}
